module.exports = __webpack_public_path__ + "static/media/icon-talent-hub.2dc8f9e3.svg";